import api from 'service/api'

export type User = {
  id: number
  fullName: string
  nickname: string
  israelId: string
  mainMobilePhone: string
  email: string
}

export const fetchUsers = async (communityId) => {
  let data = await api.getUserManagementList(communityId)

  return {
    data: data.items,
    total: data.totalCount,
  }
}
export const removeUser = async (userId, communityId) => {
  let data = await api.removeUserManagementUser(userId, communityId);
  return data 
} 

export const getAssignTags = async (userId, communityId) => {
  let data = await api.getAssingUserManagementTags(userId, communityId);
  return data 
} 
export const getFamilyRelations = async (userId, communityId) => {
  let data = await api.getUserManagementFamilyRelations(userId, communityId);
  return data
}

export const assingTags = async (payload) => {
  let data = await api.assingUserManagementTags(payload);
  return { data }
} 

export const unassignTag = async (payload) => {
  let data = await api.unassingUserManagementTags(payload);
  return { data }
}

export const fetchTags = async (communityId) => {
  let data = await api.getUserManagementTags(communityId);
  return { data } 
}

export const fetchTagTypes = async () => {
  let data = await api.getUserManagementTagTypes();
  return { data }
}

export const fetchUser = async (id: number, communityId) => {
  let data = await api.getUserManagementOne(id, communityId);
  return { data }
}

export const assignUser = async (payload) => {
  let data = await api.assingUserManagementFamily(payload);
  return { data }
}

export const fetchUserFamily = async (id: number, communityId) => {
  let data = await api.getUserManagementOneFamily(id, communityId);
  return { data }
}

export const unassignFamilyRelation = async (payload) => {
  let data = await api.removeUserManagementFamilyRelation(payload);
  return data
}

export const fetchHouseholds = async () => {
  let data = await api.getHouseholds()
  return data
}

export const getOneHousehold = async (userId, communityId) => {
  let data = await api.getOneHousehold(userId, communityId)
  return data
}
